import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

import { ILabelInProps } from './_props';

import useInputLabelInTheme from './themes';

/**
 * LabelIn Component
 */

function LabelIn({
  id,
  label,
  labelPosition,
  type = 'Input',
  variant = 'Primary',
  required = false,
}: ILabelInProps) {
  const { labelInThemeClasses, labelInOptionalThemeClasses, labelInFocusThemeClasses } = useInputLabelInTheme({
    inputType: type,
    inputVariant: variant,
  });

  if (!label || labelPosition !== 'In') return null;

  return (
    <div id={`label-in-${id}`} className={twMerge(labelInThemeClasses, labelInFocusThemeClasses)}>
      {label}

      {!required && <span className={labelInOptionalThemeClasses}> (Optional) </span>}
    </div>
  );
}

export default LabelIn;
